export interface IOfficeOverrideOptions {
  /**
   * Targets this office instead of the one selected in the switcher. Without
   * it the request carries whatever `x-office` `getAuthHeaders()` resolved.
   */
  officeId?: string;
}

/** Adds an explicit `x-office` when the caller names an office; otherwise returns the headers unchanged. */
export const withOfficeOverride = <T extends object>(
  headers: T,
  options?: IOfficeOverrideOptions,
): T | (T & { 'x-office': string }) =>
  options?.officeId ? { ...headers, 'x-office': options.officeId } : headers;
